import { request } from '@mirai/data-sources';

export const getChannelSettings = async ({ channelId } = {}) => {
  if (!channelId) return null;

  try {
    return await request({
      endpoint: `/api/channels/${channelId}/settings/public`,
      hostname: process.env.SERVICE_LOBBY,
      method: 'GET',
    });
  } catch {
    return null;
  }
};
